import { createCommonjsModule } from '../../../../_virtual/_commonjsHelpers.js';
import { _ as _typeof_1 } from './typeof.js';
import { t as toPrimitive } from './toPrimitive.js';

var toPropertyKey = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];

function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

export { toPropertyKey as t };
//# sourceMappingURL=toPropertyKey.js.map
